// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SimpleIntakeDiagnosisModel {
    static getAttributeTypeMap() {
        return SimpleIntakeDiagnosisModel.attributeTypeMap;
    }
}
SimpleIntakeDiagnosisModel.discriminator = undefined;
SimpleIntakeDiagnosisModel.additionalProperties = false;
SimpleIntakeDiagnosisModel.attributeTypeMap = [
    {
        "name": "ids",
        "baseName": "ids",
        "type": ""
    },
    {
        "name": "codes",
        "baseName": "codes",
        "type": ""
    },
];
//# sourceMappingURL=simpleIntakeDiagnosisModel.js.map